import React, { Fragment } from 'react';
import classNames from 'classnames';

const NavDropdownMenu = props => {
  const dropdownClasses = classNames({
    'nav-dropdown-menu': true,
  });
  const { children } = props;

  return (
   <div className={dropdownClasses}>
    {children}
   </div>
  )
} 
export default NavDropdownMenu;